export default (setTeam) => {
    localStorage.clear();
    setTeam({});
};
